import { stateMapperArgsSelectors } from '#packages/stateManagement';

export const { createSelector, createStructuredSelector, isSelector } =
  stateMapperArgsSelectors.selector;

export type Selector<I, O> = (input: I) => O;
